<template>
  <v-container class="shopStartPage">
    <side-navigation/>
    <router-view/>

    <scanner-dialog/>

    <v-dialog persistent eager content-class="scannerDialog"
              attach=".shopStartPage"
              v-bind:value="this.getSignaturePadState"
    >
      <v-card light class=" three-color-grad searchCard">

        <v-btn
            class="scannerDialogCloseBtn closeBtn leftRounded"
            @click="closeSignaturePad"
        >
          x
        </v-btn>

        <VueSignaturePad
            width="100%"
            height="100%"
            ref="signaturePad"
            class="signaturePad"
            :options="{options, onBegin}"
        />

      </v-card>
    </v-dialog>


  </v-container>
</template>

<script>
import SideNavigation from "@/app/global/sideNavigation";
import {mapGetters, mapMutations} from "vuex";
import ScannerDialog from "@/app/scanner/scannerDialog";


export default {
  name: "deposit",
  components: {ScannerDialog, SideNavigation},

  data:() => {
    return {
      options: {
        penColor: "#c0f",
        backgroundColor: '#ffffff'
      }
    }
  },

  methods: {
    ...mapMutations({
      setSignaturePadState: 'setSignaturePadState',
      setSignatureSVG: 'setSignatureSVG'
    }),

    closeSignaturePad() {
      //var orientation = window.innerWidth > window.innerHeight ? "Landscape" : "Portrait";

      if(!this.$refs.signaturePad.saveSignature().isEmpty) {
        var data = this.$refs.signaturePad.saveSignature('image/svg+xml').data
        var jpeg = this.$refs.signaturePad.saveSignature('image/png').data
        this.setSignatureSVG(window.atob(data.split(",")[1]))
        this.$refs.signaturePad.clearSignature()
        this.setSignaturePadState()
        let currentDeposit = JSON.parse(localStorage.getItem('currentDeposit'))
        currentDeposit['signature'] = window.atob(data.split(",")[1])
        currentDeposit['signature_jpeg'] = jpeg
        localStorage.setItem('currentDeposit', JSON.stringify(currentDeposit))
      }
      else {
        this.setSignaturePadState()
      }
    },

    onBegin() {
      this.$refs.signaturePad.resizeCanvas()
    },
  },

  computed: {
    ...mapGetters({
      getSignaturePadState: 'getSignaturePadState'
    }),
  },
}
</script>

<style>
.signaturePad > canvas {
  border-radius: 30px!important;
  background-color: white;
}
</style>
